import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.AsB1PR',
    defaultMessage: 'Organization {name}',
  },
  logo: {
    id: 'studio.k81S1y',
    defaultMessage: 'Logo',
  },
  editOrganization: {
    id: 'studio.DPrbP2',
    defaultMessage: 'Edit organization',
  },
  viewMembers: {
    id: 'studio.RNKP0a',
    defaultMessage: 'View members',
  },
  apps: {
    id: 'studio.gRiKLf',
    defaultMessage: 'Apps',
  },
  appsLoading: {
    id: 'studio.mLmrec',
    defaultMessage: 'Loading apps…',
  },
  appsError: {
    id: 'studio.fTmMeg',
    defaultMessage: 'Something went wrong when trying to fetch this organization’s apps.',
  },
  appsEmpty: {
    id: 'studio.2p9IA9',
    defaultMessage: 'This organization currently has no apps.',
  },
  blocks: {
    id: 'studio.+im1ZA',
    defaultMessage: 'Blocks',
  },
  blocksLoading: {
    id: 'studio.S8vF1o',
    defaultMessage: 'Loading blocks…',
  },
  blocksError: {
    id: 'studio.gV4n5L',
    defaultMessage: 'Something went wrong when trying to fetch this organization’s blocks.',
  },
  blocksEmpty: {
    id: 'studio.WxTxT/',
    defaultMessage: 'This organization currently has no blocks.',
  },
});
